import { render } from "./HeroiconsSolidQuestionMarkCircle.vue?vue&type=template&id=0334628c"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidQuestionMarkCircle.vue"]])

export default __exports__